__turbopack_context__.v({
  "container": "tvNRsq_container",
  "link": "tvNRsq_link",
});
